import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { SearchButtonPanel } from '../buttons/iconButtons/action/MainCollection';
import styles from './styles/BaseCommandsPanel.module.scss';
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import { SearchIcon } from '../../libs/corporate/icons/outlined/action/MainCollection';
import { debounce } from 'lodash';
import { GridFilterAction } from '../../system/hooks/useGridFilter';
import { IPanelEvent } from './PositionEditPanel';
import { CheckBox } from '../controls/checkbox';
import { v4 as uuidv4 } from 'uuid';
import { PopoverReport, PopoverReportProps } from '../popoverReport/PopoverReport';


interface ISearchGoodsModalPanel {
    dispatchGridFilter: (value: GridFilterAction) => void
    permission?: IPermission
    isModal?: boolean;
    refresh?: IPanelEvent;
    onClickOnSearchButton: () => void;
    onFocusChanged?: (taken: boolean) => void;
    hasActiveFilters?: boolean
    showCheckBoxDeleted?: boolean
    idGosContract?: string
    popOverReport?: PopoverReportProps;
}

const MIN_SEARCH_LENGTH = 3;

export const SearchGoodsModalPanel: FC<ISearchGoodsModalPanel> = (props) => {
    const [searchValue, setSearchValue] = useState<string>('');
    const { t } = useTranslation();
    const [deleted, setDeleted] = useState<boolean>(false);
    
    const searchGoods = useCallback((value: string) => {
        if (value.length >= MIN_SEARCH_LENGTH) {
            const payload = props.idGosContract
            ? `lower("SpecName") like lower('%${value}%')`
            : `lower("Name") like lower('%${value}%') or lower("SubstanceName") like lower('%${value}%') or lower("Code") like lower('%${value}%') or lower("Barcode") like lower('%${value}%') or lower("CodeKlp") like lower('%${value}%')`
            props.dispatchGridFilter({
                type: "addCustomWhereExpressionFilter",
                payload: payload
            });
        } else if (value.length === 0) {
            props.dispatchGridFilter({ type: "deleteCustomWhereExpressionFilter" });
        }
    }, [props.dispatchGridFilter]);

    const placeholder = props.idGosContract
            ? t("directory.goods.searchModalGosContract")
            : t("directory.goods.search")

    const debouncedSearch = useMemo(() => debounce(searchGoods, 1250), [searchGoods]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchValue(value);
        if (props.isModal) {
            props.onFocusChanged?.(value.length > 0);
        }
        
        if (value.length >= MIN_SEARCH_LENGTH || value.length === 0) {
            debouncedSearch(value);
        }
    };

    const handlePressEnter = () => {
        debouncedSearch.cancel();
        if (searchValue.length >= MIN_SEARCH_LENGTH || searchValue.length === 0) {
            searchGoods(searchValue);
        }
    };

    useEffect(() => {
        return () => debouncedSearch.cancel();
    }, []);
    return (
        <div className={styles.panelWrapper}>
            <div className={styles.searchField}>
                <div className={styles.searchField_SearchIcon} style={props.hasActiveFilters ? { backgroundColor: 'rgb(153, 204, 255)', borderRadius: "2px" } : {}}>
                    <SearchButtonPanel sizeVariant="mini" onClick={() => props.onClickOnSearchButton()} />
                </div>
                <Input
                    className="custom-input-withPrefix"
                    style={{ width: 400, margin: 5 }}
                    value={searchValue}
                    placeholder={placeholder}
                    prefix={<SearchIcon />}                
                    onPressEnter={handlePressEnter}
                    onChange={handleSearchChange}
                    onBlur={() => {
                        if (props.isModal) props.onFocusChanged?.(false);
                    }}
                    allowClear
                />
                {props.showCheckBoxDeleted ? (
                    <div className={styles.checkbox}>
                    <CheckBox
                        label='Удаленные'
                        defaultChecked={deleted}
                        onChanged={(checked) => {
                            props.dispatchGridFilter({ type: "showDeleted", payload: checked })
                            setDeleted(checked)
                        }}
                        id={uuidv4()}                    
                    />
                </div>
                ) : null}
            </div>
            {props.popOverReport?.items.length ? <div style={{ display: 'flex', alignSelf: 'center' }}>
                <PopoverReport
                    label={props.popOverReport.label}
                    items={props.popOverReport?.items ?? []}
                    onItemsChange={props?.popOverReport?.onItemsChange}
                    canRemove={props?.popOverReport?.canRemove}
                />
            </div> : null}
            {props.children}
        </div>
    );
}; 
